import comingSoon from '../assets/coming-soon.jpg';

const ComingSoon = () => {
    return <div className='flex w-full h-full items-center content-center'>
        <img alt="coming soon" src={comingSoon} />
    </div>
}

export default ComingSoon;